<template>
  <div class="d-flex align-items-center">
    <!-- Condition Type Selector -->
    <b-form-select
      class="mx-3"
      style="width:auto"
      v-model="selectedCondition"
      :options="conditionOptions"
      @change="handleConditionChange"
    >
    </b-form-select>

    <!-- Question Selector (Shown when Show Questions or Hide Questions is selected) -->
    <v-select
      v-if="selectedCondition !== 'Do nothing'"
      v-model="selectedQuestions"
      :options="questionOptions"
      multiple
      closable-chips
      style="min-width: 300px;max-width: 410px;"
      placeholder="Select questions"
    ></v-select>
    <!-- <b-form-select
      v-if="selectedCondition !== 'Do nothing'"
      v-model="selectedQuestions"
      :options="questionOptions"
      multiple
    ></b-form-select> -->
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: { vSelect },
  props: {
    condition: Object | Array, // Initial condition value ('Do nothing', 'Show Questions', 'Hide Questions')
    questions: Array, // Array of available question items
    onChanged: Function,
  },
  data() {
    return {
      isFirstSet: true,
      selectedCondition:"Do nothing",
      selectedQuestions: [], // Selected questions when Show Questions or Hide Questions is chosen
      conditionOptions: ["Do nothing", "Show Questions"],
    };
  },
  watch: {
    selectedCondition() {
      if (this.selectedCondition == "Do nothing") {
        this.$emit("update:condition", {});
      } else if (this.selectedCondition == "Show Questions") {
        this.$emit("update:condition", {
          show_questions: this.condition.show_questions || [],
        });
      } else if (this.selectedCondition == "Hide Questions") {
        this.$emit("update:condition", { hide_questions: [] });
      }
    },
    selectedQuestions() {
      this.handleConditionChange();
    },
    // condition() {
    //   if (!this.isFirstSet) {
    //     return;
    //   }

    //   this.selectedCondition = this.condition.show_questions
    //     ? "Show Questions"
    //     : "Do nothing";
    //   this.selectedQuestions = this.condition.show_questions
    //     ? this.condition.show_questions
    //         .filter((item) => this.questionOptions.find((q) => q.value == item))
    //         .map((item) => {
    //           return this.questionOptions.find((q) => q.value == item);
    //         })
    //         .filter((item) => !item.value)
    //     : [];
    //   this.isFirstSet = false;
    // },
  },
  computed: {
    questionOptions() {
      // Convert question items to b-form-select options
      return this.questions.map((question) => ({
        label: question.question_title,
        value: question.question_uuid, // You may need to adjust this based on your question item structure
      }));
    },
  },
  mounted() {
    setTimeout(() => {
      this.selectedCondition = this.condition && this.condition.show_questions
        ? "Show Questions"
        : "Do nothing";


      this.selectedQuestions = this.condition && this.condition.show_questions
        ? (this.condition.show_questions
            .filter((item) => this.questionOptions.find((q) => q.value == item))
            .map((item) => {
              return this.questionOptions.find((q) => q.value == item);
            }))
        : [];
    }, 500);
  },
  methods: {
    conditionChange() {
      if (
        !this.condition ||
        (!this.condition.show_questions && !this.condition.hide_questions)
      ) {
        this.$emit("update:condition", {});
      } else if (this.condition && this.condition.show_questions) {
        this.$emit("update:condition", {
          show_questions: this.selectedQuestions,
        });
      } else if (this.condition && this.condition.hide_questions) {
        this.$emit("update:condition", {
          hide_questions: this.selectedQuestions,
        });
      } else {
        this.$emit("update:condition", {});
      }
    },
    handleConditionChange() {
      // Clear selected questions when the condition type changes to 'Do nothing'
      // if (this.selectedCondition === "Do nothing") {
      //   this.selectedQuestions = [];
      // }

      if (this.selectedCondition == "Do nothing") {
        this.$emit("update:condition", {});
      } else if (this.selectedCondition == "Show Questions") {
        this.$emit("update:condition", {
          show_questions: this.selectedQuestions
            .filter((item) => !!item)
            .map((item) => item.value),
        });
      } else if (this.selectedCondition == "Hide Questions") {
        this.$emit("update:condition", {
          hide_questions: this.selectedQuestions,
        });
      }

      if (this.onChanged) {
        this.onChanged();
      }
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
